import { userConstants } from "../constants/userConstants";

let user = JSON.parse(localStorage.getItem("user"));
const initialState = {
  loggedInUser: {},
  list:{},
  status:{},
  detail:{}
};

function userGet(state) {
  return { ...state, isFetching: true, error: null, user: [] };
}
function userGetSuccess(state, action) {
  const { user } = action.user;
  return { ...state, isFetching: false, error: null, ...user };
}

function userGetError(state, action) {
  const { error } = action;
  return { ...state, isFetching: false, error: error.message };
}

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: false,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {
        loggedIn: false,
        error: action.error
      };
    case userConstants.MESSAGE_POST_DONE:
      return {
        ...state,
        messages: action.messages
      };
    case userConstants.LOGOUT:
      return {};
    case userConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.users
      };
    case userConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    case userConstants.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map(
          user => (user.id === action.id ? { ...user, deleting: true } : user)
        )
      };
    case userConstants.LIST_SUPERADMIN_REQUEST:
      return {
        loading: true
      };
    case userConstants.LIST_SUPERADMIN_SUCCESS:
      return {
        list: action.data
      };
    case userConstants.LIST_SUPERADMIN_FAILURE:
      return {
        error: action.error
      };
    case userConstants.USER_STATUS_REQUEST:
      return {
        loading: true
      };
    case userConstants.USER_STATUS_SUCCESS:
      return {
        status: action
      };
    case userConstants.USER_STATUS_FAILURE:
      return {
        error: action.error
      };
    case userConstants.POST_DATA_REQUEST:
      return {
        loading: true
      };
    case userConstants.POST_DATA_SUCCESS:
      return {
        status: action
      };
    case userConstants.POST_DATA_FAILURE:
      return {
        error: action.error
      };
    case userConstants.GET_USER_REQUEST:
      return {
        loading: true
      };
    case userConstants.GET_USER_SUCCESS:
      return {
        detail: action
      };
    case userConstants.GET_USER_FAILURE:
      return {
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/user.js